<template>
  <div class="screen">
    <div class="no-content" v-if="mealsForScreen.length <= 0">
      <meal-image
        class="meal-jumbo"
        :src="defaultImageUrl"
        style="height:100%;"
      />
    </div>
    <screen-layout v-else :template="template" :meals="mealsForScreen" />
  </div>
</template>

<script>
import MealImage from "@/components/meal-image"
import ScreenLayout from "./screen-layout"
import { state, actions } from "@/store"

export default {
  name: "screen",
  props: ["idx", "fontSize", "forceOfferId", "forceTemplateId", "forceScreens"],
  components: {
    MealImage,
    ScreenLayout
  },
  computed: {
    defaultImageUrl() {
      return state.project.data.defaultImage.imageUrl
    },
    template() {
      const templateId = this.forceTemplateId || this.offer.conf.templateId
      return state.templates[templateId]
    },
    offer() {
      const activeOffersIdxsForScreen = state.project.data.activeOfferIds.filter(
        offerId =>
          state.project.data.offers[offerId] &&
          state.project.data.offers[offerId].conf.screens[this.idx]
      )
      const offerId = this.forceOfferId || activeOffersIdxsForScreen[0]
      return (
        state.project.data.offers[offerId] || {
          id: this.offerId,
          conf: {},
          data: {
            mealIds: {}
          }
        }
      )
    },
    mealsForScreen() {
      if (!this.template) {
        return []
      }
      const screenIdxs = Object.keys(
        this.forceScreens || this.offer.conf.screens || {}
      )
      const meals = actions.getSortedOfferMeals(this.offer.id)
      const maxMeals = this.template.maxMeals || 0
      const slices = this.template.slicer(meals, screenIdxs.length, maxMeals)
      return slices[screenIdxs.indexOf(this.idx)] || []
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";

html {
  overflow-y: auto;
}

.screen {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: black;
  overflow: none;
  .no-content {
    font-size: 3vh;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    color: $device-text-color;
  }
}
</style>
